import { render, staticRenderFns } from "./Social1.vue?vue&type=template&id=66824964&scoped=true"
import script from "./Social1.vue?vue&type=script&lang=js"
export * from "./Social1.vue?vue&type=script&lang=js"
import style0 from "./Social1.vue?vue&type=style&index=0&id=66824964&prod&scoped=true&lang=less"
import style1 from "./Social1.vue?vue&type=style&index=1&id=66824964&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66824964",
  null
  
)

export default component.exports